/**
 * Shared location_slug matching for slice items (server + client).
 * Empty slug = all stores. Without a selected store, location-specific entries are hidden.
 * Comma-separated slugs are supported (e.g. "downtown, midtown").
 */
export const locationSlugMatchesStore = (
  locationSlug: string | null | undefined,
  storeUrlSlug: string | undefined,
): boolean => {
  if (!locationSlug?.trim()) {
    return true;
  }

  if (!storeUrlSlug) {
    return false;
  }

  const slugs = locationSlug.split(',').map(slug => slug.trim());

  return slugs.includes(storeUrlSlug);
};

export const filterSliceItemsByLocationSlug = <
  T extends { location_slug?: string | null },
>(
  items: T[] | null | undefined,
  storeUrlSlug: string | undefined,
): T[] => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items.filter(item =>
    locationSlugMatchesStore(item?.location_slug, storeUrlSlug),
  );
};

export const showSliceByLocationSlug = (
  locationSlug: string | null | undefined,
  storeUrlSlug: string | undefined,
): boolean => locationSlugMatchesStore(locationSlug, storeUrlSlug);

/** Prefer store-specific item; fall back to item without location_slug. */
export const pickLocationOrDefaultItem = <
  T extends { location_slug?: string | null },
>(
  items: T[],
): T | undefined => {
  if (!items.length) {
    return undefined;
  }

  const locationItem = items.find(item => item.location_slug?.trim());
  const defaultItem = items.find(item => !item.location_slug?.trim());

  return locationItem ?? defaultItem;
};
